import type { SxProps, Theme } from "@mui/material/styles";

export const animatedRecordTimerStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  fontVariantNumeric: "tabular-nums",
  letterSpacing: "0.01em",
  color: "inherit",
  flexShrink: 0,
  lineHeight: 1,
  minWidth: "5.6em",
  display: "inline-flex",
  alignItems: "center",
};

export const animatedDigitWindowStyle: SxProps<Theme> = {
  position: "relative",
  display: "inline-block",
  height: "1.05em",
  width: "1ch",
  overflow: "hidden",
  verticalAlign: "bottom",
  flexShrink: 0,
};

export const animatedDigitStyle = (
  role: "incoming" | "outgoing" | "static",
): SxProps<Theme> => ({
  position: role === "static" ? "relative" : "absolute",
  left: 0,
  top: 0,
  width: "100%",
  textAlign: "center",
  lineHeight: 1.05,
  ...(role === "incoming"
    ? {
        animation: "recSecIn 0.28s ease-out forwards",
        "@keyframes recSecIn": {
          "0%": { transform: "translateY(-110%)", opacity: 0.2 },
          "100%": { transform: "translateY(0)", opacity: 1 },
        },
      }
    : {}),
  ...(role === "outgoing"
    ? {
        animation: "recSecOut 0.28s ease-in forwards",
        "@keyframes recSecOut": {
          "0%": { transform: "translateY(0)", opacity: 1 },
          "100%": { transform: "translateY(110%)", opacity: 0 },
        },
      }
    : {}),
});
